import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/drivers/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/drivers', data)
  },
  get(id) {
    return http.get(`/api/v1/drivers/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/drivers/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/drivers/${id}/status`, null, {
      params: { status },
    });
  },
  // Vehículo asignado por defecto al conductor (DEF-ADM-018).
  defaultVehicle(id) {
    return http.get(`/api/v1/drivers/${id}/default-vehicle`)
  }
}
